import React from "react";

export default function AdmissionProcess({ course }) {
const steps = course?.admissionProcess;

return (
<section id="admission-process" className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28">
  <div className="container relative z-[1] mx-auto">

    {/* HEADER */}
    <div className="grid gap-10 lg:grid-cols-[1.1fr_.65fr] lg:items-end lg:gap-20">
      <div>
        <div className="flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
          <span className="h-px w-10 bg-current" />
          How to Apply
        </div>

        <h2
          className="mt-6 max-w-[900px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,5vw,70px)] font-normal leading-[1.03] tracking-[-0.04em] text-[#071A2F]">
          Admission Process for{" "}
          <em className="font-normal text-[#8B1E3F]">
            {course?.shortTitle || course?.title || "This Programme"}
          </em>
        </h2>
      </div>

      <div>
        <p className="text-base leading-8 text-[#687580]">
          Your journey from programme discovery to admission can be
          completed through a clear application process.
        </p>

        <a href="/apply"
          className="group mt-6 inline-flex items-center gap-6 text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">
          Start Application
          <span className="transition-transform group-hover:translate-x-1">
            →
          </span>
        </a>
      </div>
    </div>

    {/* ROUTE */}
    <div className="relative mt-16 lg:mt-20">

      {/* desktop rail */}
      <div className="absolute left-0 right-0 top-[31px] hidden h-px bg-[#071A2F]/15 lg:block" />

      <div className="grid lg:grid-cols-6">
        {steps.map((item, index) => (
        <article key={item.title} className="
                  group relative border-b border-[#071A2F]/10 py-7
                  lg:border-b-0 lg:border-r lg:px-6 lg:py-0
                  first:lg:pl-0 last:lg:border-r-0 last:lg:pr-0
                ">
          <div className="relative z-[2]">
            <span className="
                      grid h-16 w-16 place-items-center rounded-full
                      border border-[#071A2F]/15 bg-white
                      font-['Libre_Caslon_Display',Georgia,serif]
                      text-xl text-[#8B1E3F]
                      transition-all duration-300
                      group-hover:border-[#8B1E3F]
                      group-hover:bg-[#8B1E3F]
                      group-hover:text-white
                    ">
              {String(index + 1).padStart(2, "0")}
            </span>
          </div>

          <div className="mt-6">
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#A77B2D]">
              Step {index + 1}
            </span>

            <h3
              className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] font-normal leading-[1.2] text-[#071A2F]">
              {item.title}
            </h3>

            <p className="mt-4 text-sm leading-7 text-[#6B7680]">
              {item.description}
            </p>
          </div>
        </article>
        ))}
      </div>
    </div>

    {/* ACTION STRIP */}
    <div className="mt-16 grid overflow-hidden bg-[#F7F2E8] lg:grid-cols-[1fr_auto] lg:items-center">
      <div className="px-7 py-8 sm:px-10">
        <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
          Need Admission Guidance?
        </span>

        <p
          className="mt-3 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[25px] leading-[1.4] text-[#071A2F]">
          Speak with the admissions team before starting your application.
        </p>
      </div>

      <div className="flex border-t border-[#071A2F]/10 lg:border-l lg:border-t-0">
        <a href="/contact"
          className="group flex min-h-[100px] items-center gap-8 px-8 text-sm font-bold uppercase tracking-[0.12em] text-[#071A2F] transition-colors hover:bg-[#8B1E3F] hover:text-white">
          Talk to Admissions
          <span className="text-xl transition-transform group-hover:translate-x-1 group-hover:-translate-y-1">
            ↗
          </span>
        </a>
      </div>
    </div>

    <p className="mt-6 max-w-[900px] text-sm leading-7 text-[#78818A]">
      Admission requirements and procedures may vary according to the
      programme, applicant category and applicable University regulations.
    </p>
  </div>
</section>
);
}